import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'StackPopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stack-pop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 9.5l-3 1.5l8 4l8 -4l-3 -1.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 15l8 4l8 -4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 11v-7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 7l3 -3l3 3"
    }, null), _createTextVNode(" ")]);
  }
};